import env from '@/config/env';
import ModeloDetalhado from '@/graphql/tabela/queries/ModeloDetalhado.gql'
import BuscaSimilar from '@/graphql/tabela/queries/BuscaSimilar.gql'
import {errorGQLHandler} from '@/helpers/helpers';
import {map, extend, findWhere} from 'lodash';

const Types = {
  MODELO: 'MODELO',
  CLEAR_MODELO: 'CLEAR_MODELO',
  LOADING: 'LOADING',
  LOADING_SIMILAR: 'LOADING_SIMILAR',
  SIMILARES: 'SIMILARES',
};

export default {
  namespaced: true,
  state: {
    loading: true,
    loadingSimilar: false,
    modelo: null,
    similares: {
      data: [],
      paginate: {},
    },
    range: 500,
  },
  getters: {
    loading: state => state.loading,
    loadingSimilar: state => state.loadingSimilar,
    modelo: state => state.modelo,
    similares: state => state.similares,
  },
  mutations: {
    [Types.MODELO](state, payload) {
      state.modelo = payload.data;
    },
    [Types.CLEAR_MODELO](state) {
      state.modelo = null
    },
    [Types.LOADING](state, payload) {
      state.loading = payload.loading;
    },
    [Types.LOADING_SIMILAR](state, payload) {
      state.loadingSimilar = payload.loadingSimilar;
    },
    [Types.SIMILARES](state, payload) {
      state.similares = payload.similares;
    }
  },
  actions: {
    async getModelo({commit, dispatch}, {tabela, renova, modelo, tipo}) {
      commit(Types.LOADING, {loading: true});
      commit(Types.LOADING_SIMILAR, {loadingSimilar: true});
      await commit(Types.CLEAR_MODELO);
      try {
        console.log(modelo)
        console.log(typeof modelo)
        const query = await env.tabela.query({
          query: ModeloDetalhado,
          variables: {
            tabela,
            modelo,
            tipo
          },
          fetchPolicy: 'no-cache',
        });

        /**
         * Buscar os Planos
         */
        await dispatch('vcPlano/getPlanos', { tabela, renova, modelo }, { root: true });

        /**
         * Check is 'smartphone'
         */

        let [data] = query.data.response.data;
        data = { ...data, tipo }

        if (tipo === 'smartphone') {
          dispatch('getSimilar', {tabela, modelo, valor: data.preco});
        } else {
          /**
           * Quem desliga a flag e o getSimilar, que so roda para smartphone.
           * Sem isso o acessorio ficava com o spinner de similares girando
           * para sempre, prometendo um bloco que nunca vem.
           */
          commit(Types.SIMILARES, {similares: {data: [], paginate: {}}});
          commit(Types.LOADING_SIMILAR, {loadingSimilar: false});
        }

        commit(Types.LOADING, {loading: false});
        commit(Types.MODELO, {data});
      } catch (e) {
        commit(Types.LOADING_SIMILAR, {loadingSimilar: false});
        errorGQLHandler(e);
      }
    },
    async getSimilar({commit, state, rootGetters}, {tabela, modelo, valor}) {

      try {
        const range = state.range || 100;

        /**
         * Mesma regra do restante da tabela nova: sem a UF o preco de um DDD
         * qualquer venceria o nacional.
         */
        const uf = rootGetters['vcUser/ufId'] || null;

        const query = await env.tabela.query({
          query: BuscaSimilar,
          variables: {
            tabela,
            modelo,
            valor,
            range,
            uf,
          },
          fetchPolicy: 'no-cache',
        });

        const { data, ...paginate } = query.data.response;

        commit(Types.SIMILARES, { similares: { data, paginate } });
        commit(Types.LOADING_SIMILAR, {loadingSimilar: false});
      } catch (e) {
        // Falhou a busca: melhor esconder o bloco do que deixar o spinner.
        commit(Types.SIMILARES, {similares: {data: [], paginate: {}}});
        commit(Types.LOADING_SIMILAR, {loadingSimilar: false});
        errorGQLHandler(e);
      }
    }
  }
}
